import '@hapana/shared/utils/type-defs.util'

/** @type {Styles} */
export const styles = {
  dialogContent: {
    padding: 0,
  },
  equipmentRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  equipmentImage: {
    width: 48,
    height: 48,
    borderRadius: 4,
    objectFit: 'cover',
    marginRight: 8,
  },
  equipmentInfo: { flex: 1 },
  equipmentMeta: { display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center' },
  divider: { my: 2 },
  messageTitle: { mb: 1 },
  messageHelperText: { mb: 0.5 },
}
